import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Grid, Typography, Button, Link, Box } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useHistory } from 'react-router-dom';

const RequriedForEvent = () => {
    const history = useHistory();
    const [homeSetup, setHomeSetup] = useState({});
    const [settings, setSettings] = useState({});
    const [getOptionItems, setGetOptionItems] = useState({});
    const [conferenceEmails, setConferenceEmails] = useState([]);

    const [loading, setLoading] = useState(true);

    const eventid = localStorage.getItem('eventid');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [homeRes, settingsRes, optionsRes, emailTemplatesRes] = await Promise.all([
                    axios.get(`/api/add-home-setup-index?id=${eventid}`),
                    axios.get(`/api/get-setting/${eventid}`),
                    axios.get(`api/index-option-setup?id=${eventid}`),
                    axios.get(`/api/index-conference-registration-email-template?id=${eventid}`)
                ]);

                if (homeRes.status === 200) {
                    setHomeSetup(homeRes.data.HomePageSetup || {});
                }

                if (settingsRes.status === 200) {
                    setSettings(settingsRes.data.settings || {});
                }

                if (optionsRes.status === 200) {
                    setGetOptionItems(optionsRes.data.getOptions || {});
                }
                if (emailTemplatesRes.status === 200) {
                    setConferenceEmails(emailTemplatesRes.data.WorkshopEmailTemp || []);
                }
            } catch (error) {
                console.error("Error fetching data", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [eventid]);

    const renderIcon = (value) =>
        value ? <CheckIcon style={{ color: 'green' }} /> : <CloseIcon style={{ color: 'red' }} />;

    const renderIconForImage = (url) =>
        url && !url.includes('no_image.jpg')
            ? <CheckIcon style={{ color: 'green' }} />
            : <CloseIcon style={{ color: 'red' }} />;

    const banners = [
        { label: 'Event Logo', key: 'eventLogo' },
        { label: 'Abstract Banner', key: 'abstractBannerImage' },
        { label: 'Workshop Banner', key: 'workshopBannerImage' },
        { label: 'Conference Banner', key: 'conferenceBannerImage' },
    ];

    const cPayments = [
        { label: 'Conference Online Payment', key: 'c_online_status' },
        { label: 'Conference Bank Payment', key: 'c_bank_status' },
        { label: 'Conference Cash Payment', key: 'c_cash_status' },
        { label: 'Conference Free Registration', key: 'c_free_status' },
    ];

    const isSMTPConfigured = () => {
        return (
            settings.MAIL_HOST &&
            settings.MAIL_USERNAME &&
            settings.MAIL_PASSWORD &&
            settings.MAIL_PORT &&
            settings.MAIL_PROTOCOL &&
            settings.MAIL_FROM &&
            settings.ENABLED_MAIL === "1"
        );
    };

    const conferenceBadges = [
        { label: 'Conference Badge', key: 'conference_badge' },
        { label: 'Conference Affiliation Badge', key: 'conference_affiliation_badge' },
        { label: 'Exhibition Badge', key: 'guest_badge' },
    ];
    const requiredEmailTemplates = [
        { id: 15, label: "Registration" },
        { id: 17, label: "Bank Verification" },
        { id: 18, label: "Participants Reminder" },
        { id: 19, label: " Conference Coupon Email" },
       
        { id: 20, label: "Free Registration" },
        { id: 21, label: "QR Code Reminder" },
        { id: 22, label: "Free Reg Without Verify" },
        { id: 24, label: "Online Payment Registration" },
        { id: 25, label: "Affiliation Conference Bank Verification badge" },
        { id: 26, label: "Affiliation Conference Free Registration" },
        
        { id: 27, label: "Claim Coupon" }
    ];
    const hasTemplate = (titleId) => {
        return conferenceEmails.some(template => template.title_id === titleId && template.status === 1);
    };

    if (loading) return <Typography>Loading...</Typography>;

    return (
        <div>
            <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 3 }}>
                Required Setup for Event
            </Typography>

            {/* ✅ Banner Status */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 5, mb: 2 }}>
                <Typography variant="h6">
                    ✅ Banner Status
                </Typography>
                <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    sx={{ textTransform: 'none' }}
                    onClick={() => history.push('/admin/abstract/home-page')}
                >
                    Go to Banner Setup
                </Button>
            </Box>
            <hr></hr>
            <Grid container spacing={3}>
                {banners.map((item) => (
                    <Grid item xs={12} sm={6} md={3} key={item.key}>
                        <Typography>{item.label}: {renderIcon(homeSetup[item.key])}</Typography>
                    </Grid>
                ))}
            </Grid>
            <hr></hr>

            {/* ✅ Conference Payment Status */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 5, mb: 2 }}>

                <Typography variant="h6" sx={{ mt: 5, mb: 2 }}>
                    ✅ Conference Regisration Payment Status
                </Typography>
                <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    sx={{ textTransform: 'none' }}
                    onClick={() => history.push('/admin/abstract/home-page')}
                >
                    Conference Regisration Payment Status
                </Button>
            </Box>
            <hr></hr>
            <Grid container spacing={3}>
                {cPayments.map((item) => (
                    <Grid item xs={12} sm={6} md={3} key={item.key}>
                        <Typography>{item.label}: {renderIcon(homeSetup[item.key])}</Typography>
                    </Grid>
                ))}
            </Grid>
            <hr></hr>
            {/* ✅ SMTP Configuration */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 5, mb: 2 }}>
                <Typography variant="h6" sx={{ mt: 5, mb: 2 }}>
                    ✅ SMTP Configuration
                </Typography>
                <Button
                    variant="contained"
                    size="small"
                    color="primary"
                    sx={{ textTransform: 'none' }}
                    onClick={() => history.push('/admin/email/setting')}
                >
                    SMTP Configuration Section
                </Button>

            </Box>
            <hr></hr>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                    <Typography>SMTP Configured: {renderIcon(isSMTPConfigured())}</Typography>
                </Grid>
            </Grid>
            <hr></hr>
            {/* ✅ Multi-Currency Payment Status */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 5, mb: 2 }}>
            <Typography variant="h6" sx={{ mt: 5, mb: 2 }}>
                ✅ Multi-Currency Payment Status
            </Typography>
            <Button
                variant="contained"
                size="small"
                color="primary"
                sx={{ textTransform: 'none' }}
                onClick={() => history.push('/admin/payment/setting')}
            >
             Payment Currency Section
            </Button>
            </Box>
            <hr></hr>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                    <Typography>Saudi Riyal (SAR): {renderIcon(settings.PAYTAB_MODE === "1")}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Typography>UAE Dirham (AED): {renderIcon(settings.PAYTAB_MODE_ONE === "1")}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Typography>USD Dollar (USD): {renderIcon(settings.PAYTAB_MODE_TWO === "1")}</Typography>
                </Grid>
            </Grid>
<hr></hr>
            {/* ✅ Email Template Images */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 5, mb: 2 }}>
            <Typography variant="h6" sx={{ mt: 5, mb: 2 }}>
                ✅ Email Template Images
            </Typography>
            <Button
                variant="contained" 
                size="small"
                color="primary"
                sx={{ textTransform: 'none' }}
                onClick={() => history.push('/admin/general/setting')}
            >
                Email Template Images Section
            </Button>
            </Box>
            <hr></hr>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                    <Typography>Company Header Image: {renderIcon(settings.COMPANY_HEADER)}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Typography>Company Footer Image: {renderIcon(settings.COMPANY_FOOTER)}</Typography>
                </Grid>
            </Grid>
<hr></hr>
            {/* ✅ Conference Badges */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 5, mb: 2 }}>
            <Typography variant="h6" sx={{ mt: 5, mb: 2 }}>
                ✅ Conference Badges
            </Typography>
            <Button
                variant="contained" 
                size="small"
                color="primary"
                sx={{ textTransform: 'none' }}
                onClick={() => history.push('/admin/conference/badge')}
            >
                Conference Badges Section
            </Button>
              <Button
                variant="contained" 
                size="small"
                color="primary"
                sx={{ textTransform: 'none' }}
                onClick={() => history.push('/admin/options/assign')}
            >
                Exhibition Badges Section
            </Button>
              <Button
                variant="contained" 
                size="small"
                color="primary"
                sx={{ textTransform: 'none' }}
                onClick={() => history.push('/admin/affiliation/badge')}
            >
                Affiliation Badges Section
            </Button>
            </Box>
            <hr></hr>
            <Grid container spacing={3}>
                {conferenceBadges.map((item) => (
                    <Grid item xs={12} sm={6} md={3} key={item.key}>
                        <Typography>{item.label}: {renderIconForImage(getOptionItems[item.key])}</Typography>
                    </Grid>
                ))}
            </Grid>
            <hr></hr>

            {/* ✅ Email Templates Status */}
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 5, mb: 2 }}>
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
                ✅ Conference Email Templates
            </Typography>
            <Button
                variant="contained"
                size="small"
                color="primary"
                sx={{ textTransform: 'none' }}
                onClick={() => history.push('/admin/conference/index-email')}
            >
                Email Template Section
            </Button>
            </Box>
            <hr></hr>
            <Grid container spacing={2}>
                {requiredEmailTemplates.map((item) => (
                    <Grid item xs={12} sm={6} md={4} key={item.id}>
                        <Typography>
                            {item.label}: {renderIcon(hasTemplate(item.id))}
                        </Typography>
                    </Grid>
                ))}
            </Grid>
            <hr></hr>

            {/* ✅ Conference Event ID */}
        </div>

    );
};

export default RequriedForEvent;
